import { SmartSendItemApiModel } from '~/lib/api/smartsend/types';
export const GetOrderLinks = (item: SmartSendItemApiModel): { [key: string]: string } => {
  const links: { [key: string]: string } = {};
  item.MarketplaceOrderLines.forEach((mpo) => {
    if (mpo.CustomerReference && mpo.OrderLink) {
      links[mpo.CustomerReference] = mpo.OrderLink;
    }
  });
  return links;
};
